import getApiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const getDBMigrationStatus = (token: string, backend: string, dbName: string) => {
    return fetch(`${getApiUrl(backend)}tenant/${dbName}`, {
        method: "GET",
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
}

export default getDBMigrationStatus
